import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setApiJson } from '../../redux/Actions/ApiAction';
import { inputClass } from './MyConstants';

function MyInput({ placeholder, name, disable, title, error, important, uppercase, onChange, parent, value, className, type }) {

    const ApiReducer = useSelector(state => state.ApiReducer)
    const dispatch = useDispatch()

    const onChangeText = (val) => {
        if (type === 'number') {
            if (val !== '' && !/^(?:[0-9]+(?:\.[0-9]*)?)?$/.test(val)) return;
        }
        const newJson = { ...ApiReducer.apiJson };
        if (parent) {
            const parentObj = { ...(newJson[parent] || {}) };
            parentObj[name] = type === 'number' && val !== '' ? Number(val) : val;
            newJson[parent] = parentObj;
        } else {
            newJson[name] = type === 'number' && val !== '' ? Number(val) : val;
        }
        dispatch(setApiJson(newJson));
    };

    const inputValue = value !== undefined ? value : parent ? ApiReducer?.apiJson?.[parent]?.[name] ?? '' : ApiReducer?.apiJson?.[name] ?? '';

    return (
        <div>
            <p className='w-full text-black'> {title} {important && <span className='text-red-600 text-base'>*</span>}</p>
            <input type='text' style={{ textTransform: uppercase ? 'uppercase' : '' }} disabled={disable} onChange={onChange ? onChange : (e) => onChangeText(e.target.value)} className={`${disable && 'bg-gray-200'} ${inputClass} ${className || ''}`} value={inputValue} name={name} placeholder={placeholder} />
            <p className='w-full text-red-600'>{error && ApiReducer.apiJsonError[name] ? `${title} is Required` : ''}</p>
        </div>
    )
}

export default MyInput
